/** 券兑换开始和结束时间 */
export const COUPON_EXCH_INFO = {
  couponExchStartTime: '12:00:00',
  couponExchEndTime: '23:59:59',
};

/** 是否圣诞版本， 2023年1月1日之前，展示圣诞版本 */
const isNormalVer = new Date() > new Date('2023/01/01 00:00:00') || /normal/.test(location.href);
/** 印花icon配置 */
export const STAMP_ICON_CONF = isNormalVer ? {
  default: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220412171427/stamp-default.png',
  used: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20221130192702/stamp-used.png',
  empty: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220412171427/stamp-empty.png',
} : {
  default: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20221206132834/christmas-stamp-default.png',
  used: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20221208182946/christmas-stamp-used.png',
  empty: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20220412171427/stamp-empty.png',
};


/** 券面左上角标签tag配置  */
export const TAG_CONF: { [key: string]: string } = {
  new: 'NEW',
  hot: 'HOT',
};

/** 默认券分类配置 */
export const DEFAULT_COUPON_TAB_ITEM = {
  tabSort: 0,
  tabColor: 'rgba(0, 0, 0, 0.5)',
  tabActiveColor: '#07C160',
};
